/**
 * Privacy level constants
 */
export const PRIVACY_LEVELS = {
  EXCLUDE: 'exclude',
  MASK: 'mask',
  UNMASK: 'unmask'
}

/**
 * Fullstory class constants
 */
export const FS_CLASSES = {
  EXCLUDE: 'fs-exclude',
  MASK: 'fs-mask',
  UNMASK: 'fs-unmask'
}
